module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    attrs: {
      "id": "heading_id_2"
    }
  }, [_vm._v("Contents"), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Introduction"
    }
  }, [_vm._v("Introduction: "), _c('em', [_vm._v("Resurrection of Another Kind")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/03CHAP01"
    }
  }, [_vm._v("1 Character: "), _c('em', [_vm._v("Sailing with the Wind’s Full Force")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/04CHAP02"
    }
  }, [_vm._v("2 Courage: "), _c('em', [_vm._v("Overcoming Crippling Fears")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/05CHAP03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 Discipline: "), _c('em', [_vm._v("Achieving Success by Delaying Gratification")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/06CHAP04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Vision: "), _c('em', [_vm._v("Looking Beyond the Obvious")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/07CHAP05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Endurance: "), _c('em', [_vm._v("Crashing Through Quitting Points")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/08CHAP06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Tender Love: "), _c('em', [_vm._v("Walking in Someone Else’s Shoes")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/09CHAP07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 Tough Love: "), _c('em', [_vm._v("Insisting on Truth in Relationships")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/10CHAP08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 Sacrificial Love: "), _c('em', [_vm._v("Giving Without Giving Out")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/11CHAP09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 Radical Love: "), _c('em', [_vm._v("Breaking the Hostility Cycle")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/12CHAP10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 A New Day: "), _c('em', [_vm._v("The Christlikeness That We Crave")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/13CHAP11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 World-Change: "), _c('em', [_vm._v("When Character Counts Most")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/DiscussionGuide",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discussion Guide")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/AuthorInfo",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa8cef8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Contents.vue
// module id = 63
// module chunks = 0